import { render } from "./order-shipment.vue?vue&type=template&id=a840f06e"
import script from "./order-shipment.vue?vue&type=script&lang=js"
export * from "./order-shipment.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__